import React, { useEffect } from "react";
import MainLayout from "../../layout";
import { TextView } from "../../components/view-form-components/text-view";
import { DocumentView } from "../../components/view-form-components/image.view";
import ResetPasswordModal from "../../components/modal/reset-password-modal";
import { useState } from "react";
import axios from "axios";
import { url, web_url } from "../../config";
import { useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../components/modal/delete-modal";
import backArrow from "../../assets/icons/back-arrow.svg";
import Editor from "../../components/editor";
import { ToggleSwitch } from "../../components/form/checkbox";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import PreviewModal from "../../components/modal/blog-preview-modal";

const ReadNewsletter = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [openResetPassowrd, setOpenResetPassowrd] = useState(false);
  const [published, setPublished] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const previewUrl = `${web_url}/newsletter/preview/${data?.slug}`;

  const fetchData = () => {
    setLoading(true);
    axios
      .post(`${url}/model/newsletter_display/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        setPublished(res.data.data.published);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    axios
      .post(`${url}/model/newsletter_display/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/newsletter_display/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const handlePublishToggle = (checked) => {
    setPublished(checked);
    const now = new Date();

    const payload = {
      where: {
        id: params?.id,
      },
      values: {
        id: params?.id,
        title: data?.title ?? "",
        description: data?.description ?? "",
        meta_title: data?.meta_title ?? "",
        meta_description: data?.meta_description ?? "",
        listing_page_image: data?.listing_page_image ?? "",
        listing_page_image_alt_text: data?.listing_page_image_alt_text ?? "",
        newsletter_details_image: data?.newsletter_details_image ?? "",
        newsletter_details_image_alt_text:
          data?.newsletter_details_image_alt_text ?? "",
        author: data?.author ?? "",
        author_profile: data?.author_profile ?? "",
        author_profile_alt: data?.author_profile_alt ?? "",
        author_about: data?.author_about ?? "",
        author_social_media_link: data?.author_social_media_link ?? "",
        author_social_media_link_icon:
          data?.author_social_media_link_icon ?? "",
        status: data?.status ?? "draft",
        content_section:
          data?.content_section?.length > 0 ? data?.content_section : [],
        slug: data?.slug ?? "",
        property_cards_tagging: [],
        edition: data?.edition ?? "",
        published: checked,
        date_of_published: now,
        status: "published",
      },
    };

    axios
      .post(`${url}/model/newsletter_display/edit`, payload)
      .then((response) => {
        successToast(response.data.message);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
        setPublished((prev) => !prev); // rollback on failure
      });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ResetPasswordModal
        id={params?.id}
        isOpen={openResetPassowrd}
        onClose={() => setOpenResetPassowrd(false)}
      />
      <PreviewModal
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
        url={previewUrl}
      />

      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <div className="flex items-center gap-2">
            <button onClick={() => navigate(-1)} type="button">
              <img src={backArrow} alt="<" width={10} height={10} />
            </button>
            <h2 className="text-xl font-semibold capitalize">
              Newsletter - view
            </h2>
          </div>
          <div className="flex items-center gap-5">
            <button
              onClick={() => {
                setPreviewOpen(true);
              }}
              className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
            >
              Preview
            </button>
            <ToggleSwitch
              label="published"
              value={published}
              onChange={handlePublishToggle}
            />
            <button
              onClick={() => navigate(`/newsletter_display/edit/${params?.id}`)}
              className="px-4 py-1 bg-white border-[2px] border-primary text-primary rounded"
            >
              Edit
            </button>
            <button
              onClick={() => {
                setdeleteModalShow(true);
              }}
              className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
            >
              Delete
            </button>
          </div>
        </div>

        <section className="w-full max-w-[40rem]">
          <TextView label={"title"} value={data?.title} />
          <TextView label={"description"} value={data?.description} />
          <TextView label={"meta title"} value={data?.meta_title} />
          <TextView
            label={"meta description"}
            value={data?.meta_description ?? "--"}
          />
          <DocumentView
            label={"listing page image"}
            value={data?.listing_page_image ?? "--"}
          />
          <TextView
            label={"listing page image alt text"}
            value={data?.listing_page_image_alt_text ?? "--"}
          />
          <DocumentView
            label={"newsletter details image"}
            value={data?.newsletter_details_image ?? "--"}
          />
          <TextView
            label={"newsletter details image alt text"}
            value={data?.newsletter_details_image_alt_text ?? "--"}
          />

          <TextView label={"edition"} value={data?.edition ?? "--"} />
          <TextView label={"author"} value={data?.author ?? "--"} />
          <TextView label={"slug"} value={data?.slug ?? "--"} />
          <TextView label={"Read time"} value={data?.read_time ?? "--"} />
        </section>
        <div className="w-full overflow-y-auto pointer-events-none">
          <Editor
            contentData={
              data?.content_section?.length > 0 ? data?.content_section : []
            }
            setContentData={() => {}}
            read={true}
          />
        </div>
      </section>
    </MainLayout>
  );
};

export default ReadNewsletter;
